import { Box } from "@mui/material";
import { motion } from "motion/react";
import {
  Route,
  Switch,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import SalesFunnelProvider from "Providers/SalesFunnelProvider";
import { CenterPage } from "Components/CenterPage/CenterPage";
import { SalesFlowFunnelChart } from "features/salesFlow";

const SalesFlowAnalysisPageInner = () => {
  return (
    <SalesFlowFunnelChart
      emptyVariant="page"
      alwaysShowAdditionalMetrics
      noTitle
      wrapReady={(chart) => (
        <CenterPage calcHeight sm={11}>
          <Box
            component={motion.div}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            sx={{ width: "100%" }}
          >
            {chart}
          </Box>
        </CenterPage>
      )}
    />
  );
};

function SalesFlowAnalysisPage() {
  const { path } = useRouteMatch();
  const location = useLocation();
  return (
    <SalesFunnelProvider location={location}>
      <Switch>
        <Route path="/clients/:clientId/projects/:projectId/analyse/standard-reports/funnel-analysis/:crKey">
          todo
          {/* <SalesCRPage /> */}
        </Route>
        <Route exact path={path}>
          <SalesFlowAnalysisPageInner />
        </Route>
      </Switch>
    </SalesFunnelProvider>
  );
}

export default SalesFlowAnalysisPage;
